import styled from "styled-components";
import React from "react";
import {Flex} from "./StyleComponents";
import Button from '@material-ui/core/Button';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {inject, observer} from "mobx-react";
import {observable} from "mobx";
import Widget from "../stores/Widget";
import {withSnackbar} from "notistack";
import i18n from "i18next";

const EditorWrapperStyled = styled(Flex)`
    flex-direction: column;
    flex:1;
    max-width:600px;
    border-right:1px solid #282c34;
    position: relative;
    transition: transform 500ms ease;
    transform: translate(${
    (props: any) => {
        return props.isOpen ? '0' : '-100%'
    }
    });
    header{
          flex:1; 
          max-height: 60px; 
          background: #282c34;
          align-items: center;
          //justify-content: center;
          display: flex;
          color: white;
      span{
          flex: 1;
      }
      button{
        position: relative;
        left: 25px;
        background: transparent;
        border: none;
        color: white;
        cursor: pointer;
        padding: 10px;
        font-size: 17px;
      }
  };
    main{
      flex:1;
      padding:20px;
    };
    footer{
        flex:1;
        max-height: 60px;
        border-top:1px solid #282c34;
        justify-content: flex-end;
        padding-right: 10px;
        display: flex;
        align-items: center;
        button{
        margin: 10px;
        }
    };
    .fields-wrapper{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
`;

@inject('uiStore', 'campaignStore')
@observer
class EditorWrapper extends React.Component<any, any> {

    @observable loading: boolean = false;

    @observable dataChanged = false;

    onUpdateData = (widgetDateKey: string, data: any) => {
        this.dataChanged = true;
        this.props.updateData(widgetDateKey, data);
    };

    save = async () => {
        this.loading = true;

        try {
            await this.props.campaignStore.campaign.save();
            const key = this.props.enqueueSnackbar('Saving successful', {variant: 'success'});
            setTimeout(() => this.props.closeSnackbar(key), 1500);
        } catch (e) {
            const key = this.props.enqueueSnackbar('Error', {variant: 'error'});
            setTimeout(() => this.props.closeSnackbar(key), 1500);
        }

        this.dataChanged = false;
        this.loading = false;
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        const widget: Widget = this.props.campaignStore.campaign.template.selectedWidget;

        return (
            <EditorWrapperStyled {...this.props}>
                <header>
                    <button onClick={this.props.resetWidgetSelected}>
                        <FontAwesomeIcon icon="chevron-left"/>
                    </button>
                    <span>{widget && widget.config.displayName} {i18n.t('edit')}</span>
                </header>
                <main>
                    {widget && widget.renderEditor({
                        onUpdateData: this.onUpdateData,
                        widget,
                    })}
                </main>
                <footer dir={this.props.uiStore.dir}>
                    <Button variant="outlined"
                            onClick={this.props.campaignStore.campaign.template.resetWidgetSelected}>
                        {i18n.t('cancel')}
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        disabled={(this.loading || !this.dataChanged)}
                        onClick={this.save}>
                        {this.loading && (
                            <img
                                alt='loading'
                                src={process.env.NODE_ENV !== 'production' ? '/images/Dual_Ring-1s-200px-blue.svg' : '/wp-content/plugins/wp-campaigns/admin/partials/build/images/Dual_Ring-1s-200px-blue.svg'}
                                width="20px"
                                height="20px" style={{marginRight: 10}}/>)}
                        {this.loading ? i18n.t('saving') : i18n.t('save')}
                    </Button>
                </footer>
            </EditorWrapperStyled>
        );
    }
}


export default withSnackbar(EditorWrapper);
